import {FlipDown} from "./FlipDown";

export class FlipDownCounter {
    static initVterinaCounter() {
        if (document.querySelector('#vterina-counter')) {
            const element = document.querySelector('#vterina-counter');
            const timestamp = element.getAttribute('data-timestamp');
            //
            new FlipDown(parseInt(timestamp), "vterina-counter", {
                headings: ["", "", "", ""],
                showDays: false,
                increment: true
            }).start();
        }
    }
}